import { buildSteps } from "../lib/BookingContext";

export default function Stepper({ currentStep, isPaid }) {
  const steps = buildSteps(isPaid);
  return (
    <div className="mb-6 sm:mb-8" data-testid="booking-stepper">
      <div className={`grid grid-cols-${steps.length} gap-2 sm:gap-3`} style={{ gridTemplateColumns: `repeat(${steps.length}, minmax(0, 1fr))` }}>
        {steps.map((s, i) => {
          const active = currentStep === i;
          const done = currentStep > i;
          const blue = active || done;
          return (
            <div key={s.id} className="flex flex-col gap-1.5" data-testid={`step-indicator-${i}`}>
              <div
                className={`text-[11px] sm:text-sm font-extrabold tracking-wide whitespace-nowrap overflow-hidden text-ellipsis ${
                  blue ? "text-[#0466ff]" : "text-[#9A9A9A]"
                }`}
                style={{ fontFamily: "Manrope" }}
              >
                {i + 1}. {s.label}
              </div>
              <div
                className={`h-1 sm:h-1.5 rounded-full transition-all ${blue ? "bg-[#0466ff]" : "bg-[#E0E0E0]"}`}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
}
